import React, { useCallback } from 'react';

import { Filter } from '../../../Enum/Filters';
import { Form } from 'react-bootstrap';
import { filterChanged } from '../../../Store/Filter/action';
import { LoanForm, loanFormReadable } from '../../../Enum/Filters/LoanForm';

import { useDispatch } from 'react-redux';
import useGetFilterValue from '../../../Hook/Interest/UseGetFilterValue';

const LoanFormFilter: React.FC = () => {
    const dispatch = useDispatch();
    const value = useGetFilterValue(Filter.LoanForm);

    const selectLoanForm = useCallback(
        (loanForm: LoanForm): void => {
            dispatch(filterChanged(Filter.LoanForm, loanForm));
        },
        [dispatch],
    );

    return (
        <Form className="loan-form-filter" autoComplete="off">
            <Form.Group controlId="loan-form">
                <Form.Label>Aflossingsvorm</Form.Label>
                <Form.Control
                    as="select"
                    custom
                    value={value as LoanForm}
                    onChange={e => selectLoanForm(e.currentTarget.value as LoanForm)}
                >
                    <option value={LoanForm.Aflossingsvrij} key={LoanForm.Aflossingsvrij}>
                        {loanFormReadable(LoanForm.Aflossingsvrij)}
                    </option>
                    <option value={LoanForm.Lineair} key={LoanForm.Lineair}>
                        {loanFormReadable(LoanForm.Lineair)}
                    </option>
                    <option value={LoanForm.Annuïtair} key={LoanForm.Annuïtair}>
                        {loanFormReadable(LoanForm.Annuïtair)}
                    </option>
                    <option value={LoanForm.Leven} key={LoanForm.Leven}>
                        {loanFormReadable(LoanForm.Leven)}
                    </option>
                    <option value={LoanForm.Spaar} key={LoanForm.Spaar}>
                        {loanFormReadable(LoanForm.Spaar)}
                    </option>
                    <option value={LoanForm.Banksparen} key={LoanForm.Banksparen}>
                        {loanFormReadable(LoanForm.Banksparen)}
                    </option>
                    <option value={LoanForm.Beleggings} key={LoanForm.Beleggings}>
                        {loanFormReadable(LoanForm.Beleggings)}
                    </option>
                    <option value={LoanForm.Hybride} key={LoanForm.Hybride}>
                        {loanFormReadable(LoanForm.Hybride)}
                    </option>
                </Form.Control>
            </Form.Group>
        </Form>
    );
};
export default LoanFormFilter;
